/** Tokens visuais — cupons loja (marca TNV) */
export const CUPONS_LOJA_ACCENT = "#F96030";
export const CUPONS_LOJA_INK = "#1a2035";

export const cuponsLojaToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${CUPONS_LOJA_ACCENT}`,
};

export const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 1.5,
    bgcolor: "background.paper",
  },
};

export const statusToggleSx = {
  flexWrap: "wrap" as const,
  "& .MuiToggleButton-root": {
    px: 1.25,
    py: 0.75,
    textTransform: "none" as const,
    fontSize: "0.8125rem",
    "&.Mui-selected": {
      bgcolor: "rgba(249, 96, 48, 0.1)",
      borderColor: CUPONS_LOJA_ACCENT,
      color: CUPONS_LOJA_ACCENT,
      fontWeight: 600,
    },
  },
};

export const emptyStateSx = {
  py: 6,
  textAlign: "center",
  border: "1px dashed",
  borderColor: "grey.300",
  borderRadius: 2,
  bgcolor: "grey.50",
};

export const saveButtonSx = {
  background: `linear-gradient(195deg, ${CUPONS_LOJA_ACCENT}, #e04a1a)`,
};

export const modalPaperSx = {
  borderRadius: 3,
  overflow: "hidden",
  maxHeight: "92vh",
  display: "flex",
  flexDirection: "column" as const,
  width: { xs: "100%", sm: "96vw" },
  maxWidth: 860,
};

export const modalHeaderSx = {
  px: 3,
  py: 2.5,
  flexShrink: 0,
  background: `linear-gradient(135deg, ${CUPONS_LOJA_INK} 0%, #2d3561 100%)`,
  color: "#fff",
  borderBottom: `3px solid ${CUPONS_LOJA_ACCENT}`,
};

export const cupomTabsSx = {
  minHeight: 44,
  borderBottom: "1px solid",
  borderColor: "grey.200",
  "& .MuiTab-root": {
    textTransform: "none",
    fontWeight: 600,
    minHeight: 44,
  },
  "& .Mui-selected": {
    color: `${CUPONS_LOJA_ACCENT} !important`,
  },
  "& .MuiTabs-indicator": {
    backgroundColor: CUPONS_LOJA_ACCENT,
    height: 3,
  },
};

export const gridSx = {
  minHeight: 420,
  "& .MuiDataGrid-cell": {
    display: "flex",
    alignItems: "center",
  },
};

export const actionIconSx = {
  color: CUPONS_LOJA_ACCENT,
  "&:hover": { bgcolor: "rgba(249, 96, 48, 0.08)" },
};

export const switchSx = {
  "& .MuiSwitch-switchBase.Mui-checked": { color: CUPONS_LOJA_ACCENT },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    bgcolor: `${CUPONS_LOJA_ACCENT} !important`,
  },
};
